 interface INavCategoryApiItemVehicleItemModelGroupItemGradeItem 
{
	title: string,
	url: string,
	img: string,
	buy: boolean
} 
 interface INavCategoryApiItemVehicleItemModelGroupItem 
{
	title: string,
	url: string | null,
	grades: Array<INavCategoryApiItemVehicleItemModelGroupItemGradeItem> 
} 
 interface INavCategoryApiItemVehicleItem 
{
	title: string,
	url: string,
	img: string,
	modelgroups: Array<INavCategoryApiItemVehicleItemModelGroupItem>
}
 interface INavCategoryApiItem
{
	title: string,
	vehicles: Array<INavCategoryApiItemVehicleItem>
}
interface IFilterAnalyticsItem {
	name: string,
	value: string
}

interface IECommerceAnalyticsItem {
	index: string, //"@@POSITION@@",
	item_id: string, //"@@VEHICLEMATERIALCODE@@",
	item_name: string, //"@@VEHICLEDESCRIPTION@@",
	item_brand: string,
	item_category: string, //"New Vehicles",
	item_category2: string, //"@@VEHICLEMODEL@@",
	item_category3: string, //"@@VEHICLEGRADE@@",
	item_category4: string, //"@@VEHICLETYPE@@",
}
interface IECommerceAnalyticsTotal {
	all_vehicles: number, 
	demonstrator: number,
	new_in_stock: number,
	test_drive: number,
	virtual: number,
}

function jqOn(el, evt: string, sel: string, handler: Function){
    el.addEventListener(evt, function(event){
        let t = event.target;
        while (t && t !== this){
            if (t.matches(sel)){
                handler.call(t, event);
            }
            t = t.parentNode;
        }
    });
}
function handleProtectClick(e: MouseEvent){
	e.stopPropagation();
	e.stopImmediatePropagation();
}
function handleBodyClick(e: MouseEvent){
	const btns: NodeListOf<HTMLElement> = document.querySelectorAll("[aria-pressed=true][data-popup-dismiss]");
	btns.forEach(function(el){
		if (el.getAttribute('aria-controls') == (e.target as HTMLButtonElement).getAttribute('aria-controls')) return;
		const list: NodeListOf<HTMLElement> = document.querySelectorAll("[aria-controls=" + el.getAttribute("aria-controls") + "]");
		setAria(list, 'aria-pressed', false);
	});
}
function handleAggToggle(e: MouseEvent){
	const el = this;
	const attr = el.getAttribute("aria-pressed") ? 'aria-pressed' : el.getAttribute("aria-selected") ? 'aria-selected' : '';
	const open = el.getAttribute(attr) || '';
	const isOpen = open.toLowerCase() == "true";
	const role = el.getAttribute("role") || '';
	const isTab = role.toLowerCase() == "tab";
	const popup = el.getAttribute("aria-haspopup") || '';
	const isPopup = popup.toLowerCase() == "true";
	const list: NodeListOf<HTMLElement> = document.querySelectorAll("[aria-controls=" + el.getAttribute("aria-controls") + "]");

	if (isTab && isOpen){
		return;
	}
	if (isPopup){
		document.body.classList.toggle("agg-disable-scrolling", !isOpen);
	}
	if (isTab){
		const tablist = el.closest("[role=tablist]");
		const allTabs: NodeListOf<HTMLElement> | undefined = tablist?.querySelectorAll("[role=tab]");
		allTabs && setAria(allTabs, attr, false);
	}
	setAria(list, attr, !isOpen);
}
function handleScrollClick(e: MouseEvent){
	e.preventDefault();
	var id = this.getAttribute("href");
	if (!id || id.length < 2 || 0 != id.indexOf('#')) return;
	var el = document.querySelector(id);
	if (!el) return;

	var top = el.getBoundingClientRect().top + window.scrollY;
	window.scrollTo({
		top: top,
		behavior: "smooth"
	});	
}
function bindToggles(): void {
	jqOn(document, 'click', '.agg-toggle[aria-controls]', handleAggToggle);
	jqOn(document, 'click', '[data-popup-protect]', handleProtectClick);
	jqOn(document, 'click', "a.agg-scroll[href^='#']", handleScrollClick);
	jqOn(document, 'click', 'body', handleBodyClick);
}
function setAria(list: NodeListOf<HTMLElement>, attr: string, pressed: boolean): void {
    list.forEach(function(el) {
        const id = el.getAttribute("aria-controls") || '';
        const controlled = id.length ? document.getElementById(id) : null;
        attr && el.setAttribute(attr, pressed.toString().toLowerCase());
        controlled && controlled.setAttribute("aria-hidden", (!pressed).toString().toLowerCase());
    });
}
async function buildMegaSwitch(dealerID: number, path: string, domain: string): Promise<any> {
	const baseUrl = 'https://stagingapp.toyotainventory.com.au/';

    return await fetch(baseUrl + "api/NavCategory?dealerid=" + dealerID).then(o => o.json()).then((dNav: Array<INavCategoryApiItem>) => {
		let currentTabNum = -1;
		let hasSetCurrentTabPanel = false;
		let markupPanels = '';
		const parts = location.pathname.split('/');
		const isHybrid = !!parts.filter(p => p.includes('hybrid')).length;

		dNav.forEach(function(category: INavCategoryApiItem, x: number){
			let markup = '<ul>';
			category.vehicles.forEach(function(vehicle: INavCategoryApiItemVehicleItem, i: number){
				let isCurrentModel = parts.includes(vehicle.title.toLowerCase());
				let isOpen = isCurrentModel && !hasSetCurrentTabPanel;

				if (vehicle.modelgroups.length){
					if (vehicle.modelgroups[0].grades.length){
						const isGradeHybrid = -1 != vehicle.modelgroups[0].grades[0].url.indexOf('hybrid');
						if (isHybrid != isGradeHybrid){
							isCurrentModel = false;
							isOpen = false;
						}
					}
				}
				if (isOpen){
					// this is to ensure only one nav is open and it's the first one found. This is mostly because of hybrid category having the same urls.
					// currentVehicleNum = i;
					// hasSetCurrentVehicleNum = true;
					currentTabNum = x;
					hasSetCurrentTabPanel = true;
				}
				markup += '<li class="category-model ' + (isOpen ? ' original' : '') + '">\
				<div class="model-head">\
					<button type="button" class="agg-toggle" aria-label="Expand or collapse" aria-pressed="' + (isOpen ? 'true' : 'false') + '" aria-controls="nvi-grade-type-' + x + '-' + i + '">\
						<img src="' + vehicle.img + '" />\
						<h3>' + vehicle.title + '</h3>\
					</button>\
				</div>';
				markup += '<div aria-hidden="' + (isOpen ? 'false' : 'true') + '" class="nvi-grade-types" id="nvi-grade-type-' + x + '-' + i + '">';
				vehicle.modelgroups.forEach(function(type: INavCategoryApiItemVehicleItemModelGroupItem, y: number){
					markup += '<div class="grade-type">';
					markup += '<h4>' + type.title + '</h4>';
					type.grades.forEach(function(grade: INavCategoryApiItemVehicleItemModelGroupItemGradeItem, z: number) {
						const isCurrentGrade = parts.includes(grade.title.toLocaleLowerCase());
						markup += '<a href="https://' + domain + grade.url + '"' + 'class="button-outline ' + ((isCurrentModel && isCurrentGrade) ? 'active' : '') + '">' + (grade.title ? grade.title : vehicle.title) + '</a>';
					});
					markup += '</div>';
				});
				markup += "</div>"
				markup += '</li>';
			});
			markup += '</ul>'

			markup = '<div role="tab" class="nvi-cars-tabpanel" aria-hidden="' + (x == currentTabNum ? 'false' : 'true') + '" id="nvi-cars-tabpanel-' + x + '">' + markup + '</div>';
			markupPanels += markup;
		});

		let markupList = '';
		dNav.forEach(function(category: INavCategoryApiItem, x: number) {
			markupList += '<li role="presentation"><button role="tab" aria-selected="' + (x == currentTabNum ? 'true' : 'false') + '" aria-controls="nvi-cars-tabpanel-' + x + '" class="agg-toggle">' + category.title + '</button></li>';
		});
		const carMenu = document.getElementById('nvi-car-menu');
		if (carMenu){
			const listEl = document.createElement('ul');
			const panelEl = document.createElement('div');

			listEl.innerHTML = markupList;
			listEl.classList.add('nvi-cars-tablist');
			listEl.setAttribute('role', 'tablist');
			panelEl.innerHTML = markupPanels;
			panelEl.classList.add('nvi-cars-tabpanels');
			
			if (!panelEl.querySelector('.original')){
				const btn = listEl.querySelector('.nvi-cars-tablist button[aria-controls]');
				const pnl = panelEl.querySelector('[aria-hidden]');
				pnl?.setAttribute('aria-hidden', 'false');
				btn?.setAttribute('aria-selected', 'true');
			}

			carMenu.appendChild(listEl);
			carMenu.appendChild(panelEl);
		}
		setTimeout(adjustFixedMenuPadding, 200);
	}).catch((e) => {
		console.log('error',e)
		return null;
	});
}
function adjustFixedMenuPadding(): void {
	document.querySelectorAll(".nvi-fixed-menu").forEach(function(me){
		const children = Array.from(me.children);
		let total = 0;
		for (let i = 0; i < children.length; i++){
			const kid = children[i];
			const cs = getComputedStyle(kid);
			if (cs.position == "fixed") {
				kid.setAttribute('style', `top: ${total}px;`);
				total += (kid as HTMLElement).offsetHeight;
			}
		}
		me.setAttribute('style', `padding-top: ${total}px;`);
	});
}
function setNoStockSection(show: boolean): void {
	const nos = document.querySelectorAll('.tb-list-section-inner-no-stock');
	nos.forEach(function(n){
		const sec = n.closest('.tb-list-section');
		sec && sec.classList.toggle('tb-no-items', !show);
	});
}
function setFilterTiles(u: Array<string>, filtersApplied: Array<IFilterAnalyticsItem>): void {
	const lists = document.querySelectorAll('.tb-list-list');
	const itemsForAnalytics: Array<Element> = [];
	lists.forEach((l) => {
		const myItems: Array<Element> = [];
		const nf = (l as HTMLUListElement).dataset.noFilter;
		if (typeof nf != 'undefined') return;
		const libanner = l.querySelector('.tb-list-item-banner');
		if (!libanner) return;
		const urls = u.length ? u : Array.from(l.querySelectorAll('a')).map(a => a.getAttribute('href')).filter(a => !!a);
		const lis = l.querySelectorAll('.tb-list-item');
		lis.forEach(li => {
			l.append(li);
		});
		urls.forEach(u => {
			lis.forEach((li,i) => {
				let hasUrl = false;
				const liAnchors = li.querySelectorAll('a[href]');
				liAnchors.forEach(a => {
					const aUrl = a.getAttribute('href') || '';
					if (u && aUrl && aUrl.includes(u)){
						hasUrl = true;
					}
				});
				if (hasUrl){
					l.insertBefore(li, libanner);
					itemsForAnalytics.push(li);
					myItems.push(li);
				}
			});
		});
		const sec = l.closest('.tb-list-section');
		sec && sec.classList.toggle('tb-no-items', !myItems.length);
	});
	setTimeout(function(){
		setBannerBg();
		emitFilterFinished();
	},10);
	sendListAnalytics(filtersApplied, itemsForAnalytics);
}
function emitFilterFinished(): void {
	const evt = new Event('filterFinished');
	document.dispatchEvent(evt);
}
function sendListAnalytics(filtersApplied: Array<IFilterAnalyticsItem>, items: Array<Element>){
	pushNewVehicleListView(filtersApplied);
	const totals: IECommerceAnalyticsTotal = {
		all_vehicles: 0, 
		demonstrator: 0,
		new_in_stock: 0,
		test_drive: 0,
		virtual: 0,
	};
	const analyticsItems: Array<IECommerceAnalyticsItem> = [];
	items.forEach((listItem) => {
		const el = (listItem as HTMLElement);
		const listEl = el.closest('[data-list-type]') as HTMLElement;
		const listType = listEl ? listEl.dataset.listType || '' : '';
		analyticsItems.push({
			index: el.dataset.index || '(not set)',
			item_id: el.dataset.id || '(not set)',
			item_name: el.dataset.name || '(not set)',
			item_brand: el.dataset.itemBrand || '(not set)',
			item_category: el.dataset.itemCategory || '(not set)',
			item_category2: el.dataset.itemCategory2 || '(not set)',
			item_category3: el.dataset.itemCategory3 || '(not set)',
			item_category4: el.dataset.itemCategory4 || '(not set)',
		});
		listType && totals[listType]++;
		totals.all_vehicles++;
	});
	pushECommerceList(analyticsItems, totals);
}
function pushNewVehicleListView(filters: Array<IFilterAnalyticsItem>){
	const dataLayer = (window as any).dataLayer || [];
	const obj: any = {
		event: "new_vehicle_list_view"
	};
	if (filters.length){
		obj.filters = filters.map((o) => {
			return {
				filter_name: o.name,
				filter_value: o.value
			};
		});
	}
	dataLayer.push(obj);
}
function pushECommerceList(items: Array<IECommerceAnalyticsItem>, totals: IECommerceAnalyticsTotal){
	const dataLayer = (window as any).dataLayer || [];
	const dl0 = dataLayer.filter(o => o.event == 'new_vehicle_list_view');
	if (!dl0.length) return;

	const model = dl0[0].vehicle_model;
	const grade = dl0[0].vehicle_grade;
	const obj2 = {
		event: "view_item_list",
		item_list_id: `nvi_${model}_${grade}`, 
		item_list_name: `New Vehicles - ${model} - ${grade}`,
		items: items,
		totals: {
			all_vehicles: totals.all_vehicles.toString(), 
			demonstrator: totals.demonstrator.toString(),
			new_in_stock: totals.new_in_stock.toString(),
			test_drive: totals.test_drive.toString(),
			virtual: totals.virtual.toString(),
		}
	};
	dataLayer.push(obj2);
}
function runWindowScripts(){
	const ls = (window as any).loadScripts || [];
	for (let i = 0; i != ls.length; ++i){
		if (typeof ls[i] == 'function'){
			ls[i]();
		}
	}
}
function pauseJwPlayers(){
    if (typeof (window as any).jwplayer !== "undefined" && (window as any).jwplayer) {
        var jws = document.querySelectorAll('.jwplayer');
        for (var i = 0; i != jws.length; ++i){
            var jwState = (window as any).jwplayer(jws[i]).getState().toUpperCase();
            if (jwState == "PLAYING" || jwState == "BUFFERING"){
                (window as any).jwplayer(jws[i]).pause();
            }
        }
    }
}
function bindModals(): void {
	const protecteds = document.querySelectorAll('[data-modal-protected]');
	protecteds.forEach(function(p){
		p.addEventListener('click', function(e){
			e.stopPropagation();
		});
	});
	const dismisses = document.querySelectorAll('[data-modal-dismiss]');
	dismisses.forEach(function(d){
		d.addEventListener('click', function(e){
			e.preventDefault();
			var me = this;
			var modal = me.closest("[role=dialog]");
			var id = me.getAttribute("id");
			var btns = document.querySelectorAll("[data-modal-id=" + id + "]");
			modal.setAttribute("aria-hidden", "true");
			btns.forEach(function(b){
				b.setAttribute("aria-expanded", "false");
			});
			document.body.setAttribute("data-modal-open", "false");
			// $('body').trigger('resize');
			
			pauseJwPlayers();
		
			var vid = me.querySelectorAll("video");
			if (vid.length) {
				vid[0].pause();
			}
			var iframe = me.querySelectorAll("iframe");
			if (iframe.length) {
				iframe.forEach(function(i){
					i.setAttribute('data-src', i.getAttribute('src'));
					i.setAttribute('src', '');
				});
			}
		});
	});
	const modals = document.querySelectorAll('[data-modal-id]');
	modals.forEach(function(m){
		m.addEventListener('click', function(){
			var me = this;
			var modalId = me.getAttribute("data-modal-id");
			var modal = document.getElementById(modalId);
			if (modal) {
				var iframe = modal.querySelector("iframe");
				if (iframe && '' == iframe.getAttribute('src')){
					iframe.setAttribute('src', iframe.getAttribute('data-src') || '');
				}
				me.setAttribute("aria-expanded", "true");
				modal.setAttribute("aria-hidden", "false");
				document.body.setAttribute("data-modal-open", "true");
			}
		});
	});
}
function setBannerBg()
{
	const els = document.querySelectorAll('.tb-list-item-banner .tb-list-item-content > *');
	els.forEach(function(obj){
		const anchor = (obj as HTMLElement);
		const styles = window.getComputedStyle(anchor);
		const bgSize = parseInt(styles.getPropertyValue('background-size').replace('auto','').replace('px','').trim());
		// anchor.classList.toggle('tb-top', !isNaN(bgSize) && anchor.offsetHeight > bgSize);
	});
	
}
function handleResize(): void {
	clearTimeout((window as any).resizeTimer);
	(window as any).resizeTimer = setTimeout(function(){
		setBannerBg();
	},250);	
}
function bindAnalytics(){
	bindSelectItems();
}
function bindSelectItems(){
	const dataLayer = (window as any).dataLayer || [];
	const tiles = document.querySelectorAll('.tb-list-item a[href]');

	tiles.forEach(function(t){
		t.addEventListener('click', function(e: Event){
			e.preventDefault();
			const url = this.getAttribute('href') || '';
			const target = this.getAttribute('target') || '_self';
			const li = this.closest('.tb-list-item');
			const model = li.dataset.itemCategory2 || '';
			const grade = li.dataset.itemCategory3 || '';
			dataLayer.push({
				event: "select_item",
				item_list_id: `nvi_${model}_${grade}`, 
				item_list_name: `New Vehicles - ${model} - ${grade}`,
				items: [
					{
						index: li.dataset.index || '(not set)',
						item_id: li.dataset.id || '(not set)',
						item_name: li.dataset.name || '(not set)',
						item_brand: "Toyota",
						item_category: li.dataset.itemCategory || '(not set)',
						item_category2: li.dataset.itemCategory2 || '(not set)',
						item_category3: li.dataset.itemCategory3 || '(not set)'
					}
				]
			});
			setTimeout(function(){
				window.open(url, target);
			},100);
		});
	});
}
function bindJwAnalytics(): void {
	if (typeof (window as any).jwplayer == 'undefined') return;
	console.log('bindJwAnalytics 1');
	(window as any).jwplayer().on('play', function() {
		console.log('jw play 1');
		const current = (window as any).jwplayer().getPlaylistItem();
		(window as any).dataLayer.push({
			event: "video_start",
			video_title: current.title,
			video_url: current.file
		})
	});
	(window as any).jwplayer().on('complete', function() {
		console.log('jw complete 1');
		const current = (window as any).jwplayer().getPlaylistItem();
		(window as any).dataLayer.push({
			event: "video_complete",
			video_title: current.title,
			video_url: current.file
		})
	});
}
function initBz4XMsgBanner(): void {
	const urlParams = new URLSearchParams(window.location.search);
	const isNotParticipating = urlParams.get('notparticipating');
	if (!isNotParticipating) return;
	const m = 'bZ4X';

	const markup = `
		<div class="agg-modal">
			<button class="agg-modal-close" aria-label="Close"></button>
			<div class="agg-modal-inner" data-modal-protected>
				<div class="agg-modal-content">
					<h2>We are not a participating&nbsp;dealer</h2>
				</div>
				<div class="agg-modal-footer">
					<button type="button" class="agg-modal-button" data-modal-dismiss>
					Please see our ${m} stock
						<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 7H16M16 7L9.7931 1M16 7L9.7931 13" stroke="#EB0A1E" stroke-linecap="square"/>
						</svg>
					</a>
				</div>
			</div>
		</div>
	`;
	const overlay = document.querySelector('.agg-modal-overlay');
	if (!overlay) return;
	const el = document.createElement('div');
	el.classList.add('agg-modal-holder');
	el.classList.add('nvi-not-participating');
	el.setAttribute('id', 'not-participating-modal');
	el.setAttribute('role', 'dialog');
	el.setAttribute('aria-label', 'We are not a participating bZ4X dealer');
	el.setAttribute('aria-hidden', 'false');
	el.setAttribute('data-modal-dismiss', '');
	el.innerHTML = markup;
	overlay.parentElement?.insertBefore(el, overlay);
}
function handleLoad(): void {
	setBannerBg();
	bindToggles();
	initBz4XMsgBanner();
	bindModals();
	bindAnalytics();
	// bindJwAnalytics();
	runWindowScripts();
}
(window as any).resizeTimer = 0;
window.addEventListener('load', handleLoad);
window.addEventListener('resize', handleResize);
window.addEventListener('orientationchange', handleResize);